import { type FormEvent, useState } from 'react';
import { useApi } from '@plataforma/web/api';
import type { Vehiculo } from '../paginas/tipos';

const CAMPOS = [
  ['anio', 'Año modelo'],
  ['marca', 'Marca'],
  ['modelo', 'Modelo'],
  ['version', 'Versión o serie'],
  ['motor', 'Motor'],
  ['carroceria', 'Carrocería'],
  ['transmision', 'Transmisión'],
  ['traccion', 'Tracción'],
  ['paisPlanta', 'País de la planta'],
] as const;

/** Corrección a mano de los datos de fábrica (p. ej. un VIN europeo que NHTSA no conoce). */
export function CorregirFabrica({ v, alGuardar }: { v: Vehiculo; alGuardar: () => void }) {
  const api = useApi();
  const [abierto, setAbierto] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const redecodificar = async () => {
    setError(null);
    try {
      await api('POST', `/inventory/vehiculos/${v.id}/decodificar`);
      alGuardar();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  if (!abierto)
    return (
      <>
        {error && <span className="error">{error}</span>}
        <button
          className="boton"
          onClick={() => void redecodificar()}
          title="Consulta otra vez NHTSA vPIC y reemplaza los datos de fábrica"
        >
          Volver a decodificar el VIN
        </button>
        <button className="boton" onClick={() => setAbierto(true)}>
          Corregir datos de fábrica
        </button>
      </>
    );
  const enviar = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    const fabrica = Object.fromEntries(
      CAMPOS.map(([clave]) => {
        const valor = String(f.get(clave) ?? '').trim();
        return [clave, clave === 'anio' ? (valor ? Number(valor) : null) : valor || null];
      }),
    );
    try {
      await api('PATCH', `/inventory/vehiculos/${v.id}`, { fabrica });
      setAbierto(false);
      alGuardar();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  return (
    <form
      className="cuerpo formulario"
      onSubmit={(e) => void enviar(e)}
      style={{ borderTop: '1px solid var(--borde-suave)' }}
    >
      {CAMPOS.map(([clave, texto]) => (
        <label key={clave} className="campo">
          <span>{texto}</span>
          <input
            name={clave}
            defaultValue={v[clave] ?? ''}
            {...(clave === 'anio'
              ? { type: 'number', min: 1950, max: new Date().getFullYear() + 1 }
              : { maxLength: 80 })}
          />
        </label>
      ))}
      {error && (
        <p className="error" style={{ gridColumn: '1 / -1' }}>
          {error}
        </p>
      )}
      <div className="acciones">
        <button type="button" className="boton" onClick={() => setAbierto(false)}>
          Cancelar
        </button>
        <button className="boton primario">Guardar corrección</button>
      </div>
    </form>
  );
}
